import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

export const Customerdetaildrawer = ({
  isOpen,
  onClose,
  customerData,
  token,
  onUpdate,
  phone, // contact number from parent
}) => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    whatsapp: "",
    address: {
      street: "",
      landmark: "",
      city: "",
      state: "",
      zip: "",
    },
  });

  // Prefill form when drawer opens or customerData changes
  useEffect(() => {
    if (!isOpen) return;

    if (customerData || phone) {
      setFormData({
        firstname: customerData.firstname || "",
        lastname: customerData.lastname || "",
        email: customerData.email || "",
        whatsapp: customerData.whatsapp || phone || "",
        address: {
          street: customerData.address?.street || "",
          landmark: customerData.address?.landmark || "",
          city: customerData.address?.city || "",
          state: customerData.address?.state || "",
          zip: customerData.address?.zip || "",
        },
      });
    }
  }, [customerData , isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("address.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        address: { ...prev.address, [key]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!onUpdate) {
      toast.error("Update function not provided!");
      return;
    }

    // Basic validation
   // if (!formData.firstname.trim()) {
     // toast.error("First name is required");
     // return;
   // }
    
    //if (!formData.email.trim()) {
     // toast.error("Email is required");
    //  return;
   // }
    
    // Email validation
    if (formData.email?.trim()) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return;
    }
     }

     if (formData.whatsapp && formData.whatsapp.length !== 10) {
      toast.error("WhatsApp number must be 10 digits");
      return;
    }

    // Prepare payload with correct field names
    const payload = {
      firstName: formData.firstname || " ",
      lastName: formData.lastname || " ",
      email: formData.email || " " ,
      whatsapp: formData.whatsapp || " ",
      contact: phone || "", // This is required - must match what's in DB
      gender: "other", // Add if you have gender field
      
      // Address mapping
      address: {
        home: formData.address.street || "",
        address1: formData.address.street || "", // Some backends expect this
        landmark: formData.address.landmark || "",
        city: formData.address.city || "",
        state: formData.address.state || "",
        pincode: formData.address.zip || "",
      }
    };

    try {
      await onUpdate(payload);
    } catch (err) {
      console.error("Submit error:", err);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-[1000]"
        onClick={onClose}
      />

      {/* Drawer */}
      <div
        className={`
          fixed inset-y-0 right-0 w-full max-w-md bg-white shadow-2xl flex flex-col
          transform transition-transform duration-300 z-[1000]
          ${isOpen ? "translate-x-0" : "translate-x-full"}
        `}
      >
        {/* Header - Matches CartDrawer exactly */}
        <div className="flex justify-between items-center px-5 py-4 border-b bg-orange-50">
          <h2 className="text-lg font-semibold text-gray-800">
            Edit Customer Details
          </h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800"
          >
            <FaTimes size={22} />
          </button>
        </div>

        {/* Form Content */}
        <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-5 space-y-6">
          {/* Profile Information */}
          <div>
            <h3 className="text-base font-semibold text-gray-800 mb-4">
              Profile Information
            </h3>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    First Name
                  </label>
                  <input
                    type="text"
                    name="firstname"
                    value={formData.firstname}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="John"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="lastname"
                    value={formData.lastname}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="Doe"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  placeholder="john@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  WhatsApp Number
                </label>
                <input
                  type="text"
                  name="whatsapp"
                  value={formData.whatsapp}
                  //onChange={handleChange}
                  onChange={(e) => {
                      // ✅ Allow only digits & max 10
                      const value = e.target.value.replace(/\D/g, "").slice(0, 10);

                      setFormData((prev) => ({
                        ...prev,
                        whatsapp: value,
                      }));
                    }}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  placeholder="+91 98765 43210"
                />
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Enter a 10-digit mobile number
              </p>
            </div>
          </div>

          {/* Address Information */}
          <div>
            <h3 className="text-base font-semibold text-gray-800 mb-4">
              Address Information
            </h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Street / House No.
                </label>
                <input
                  type="text"
                  name="address.street"
                  value={formData.address.street}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  placeholder="123 Main Road"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    Landmark (Optional)
                  </label>
                  <input
                    type="text"
                    name="address.landmark"
                    value={formData.address.landmark}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="Near park"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    City
                  </label>
                  <input
                    type="text"
                    name="address.city"
                    value={formData.address.city}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="Mumbai"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    State
                  </label>
                  <input
                    type="text"
                    name="address.state"
                    value={formData.address.state}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="Maharashtra"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    Pincode
                  </label>
                  <input
                    type="text"
                    name="address.zip"
                    value={formData.address.zip}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="400001"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>

        {/* Footer Button - Matches CartDrawer */}
        <div className="p-5 border-t bg-gray-50">
          <button
            type="submit"
            onClick={handleSubmit}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-medium transition-all"
          >
            Save Changes
          </button>
        </div>
      </div>
    </>
  );
};